import { ErrorHandler } from '@angular/core';
import { isEmpty } from 'lodash-es';
import { getIsNullable } from 'src/app/core/nullable-utils';

const emailRegex = /^.*@(.*)$/;

export const getEmailDomain = (email: string): string => {
  const res = emailRegex.exec(email)?.at(1);
  if (getIsNullable(res) || isEmpty(res)) {
    throw new Error(`Failed to get email domain from input: ${email}`);
  }
  return res;
};

export const tryGetEmailDomain = (email: string, errorHandler: ErrorHandler): string => {
  try {
    return getEmailDomain(email);
  } catch (error) {
    errorHandler.handleError(error);
    return '';
  }
};
